module.exports = __webpack_public_path__ + "static/media/Sandile_gaussian2.b9d1be53.png";